import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject, OnInit,
  ViewContainerRef,
} from '@angular/core';

import { OverlayService } from '@core/services';
import { ExchangeRatesFacade } from '@core/facades/exchange-rates.facade';

@Component({
  // TODO: Move to standalone (main.ts/app.module.ts)
  selector: 'cheelee-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit {
  private readonly exchangeRatesFacade = inject(ExchangeRatesFacade);

  private readonly overlayService = inject(OverlayService);

  private readonly vcr = inject(ViewContainerRef);

  ngOnInit(): void {
    this.exchangeRatesFacade.getCurrencyPair();
  }

  ngAfterViewInit(): void {
    this.overlayService.setDialogContainer(this.vcr);
  }
}
